import {
  Collapse,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { styled } from '@mui/styles';
import React, { MouseEventHandler, ReactNode } from 'react';

import WsColors from '../../WsColors';
import { ArrowButton } from '../ArrowButton';
import { Item } from '../Item';

export interface WsListMenuItem {
  id: number;
  label: string;
  onClick?: (id: number) => void;
}

export type WsParentListMenuItem = WsListMenuItem & {
  subList?: WsListMenuItem[];
};

export interface IFormWizard {
  title?: string;
  menuItems: WsParentListMenuItem[];
  currentStep: number;
  currentChildStep?: number;
  children: ReactNode;
  onArrowButtonClick?: MouseEventHandler;
}
const BorderedGrid = styled(Grid)(() => ({
  background: WsColors.TheBlues900,
  borderRadius: ' 8px 0px 0px 8px',
}));
const StyledCollapse = styled(Collapse)(() => ({
  borderLeft: '1px solid grey',
  marginLeft: '20px',
  timeout: 'auto',
}));
const FormWizard: React.FC<IFormWizard> = ({
  title,
  menuItems,
  children,
  currentStep,
  currentChildStep,
  onArrowButtonClick,
}) => (
  <Grid container>
    <BorderedGrid item xs={3}>
      <Item>
        {title && <ArrowButton onClick={onArrowButtonClick} title={title} size="large" />}
        <List>
          {menuItems.map((listArrayItem: WsParentListMenuItem, index: number) => (
            <>
              <ListItem
                key={index}
                onClick={() => {
                  if (listArrayItem.onClick) {
                    listArrayItem.onClick(listArrayItem.id);
                  }
                }}
              >
                <Typography
                  color={index === currentStep ? WsColors.TheBlues400 : WsColors.TertiaryShades500}
                  mr={2}
                  fontWeight={700}
                >
                  {index < 9 && 0}
                  {index + 1}.
                </Typography>

                <ListItemText
                  primary={listArrayItem.label}
                  primaryTypographyProps={{
                    color: index === currentStep ? WsColors.White : WsColors.TertiaryShades500,
                    fontWeight: 700,
                  }}
                />
              </ListItem>
              {listArrayItem.subList && listArrayItem.subList.length > 0 && (
                <StyledCollapse in={index === currentStep}>
                  <List component="div" disablePadding>
                    {listArrayItem.subList?.map((subItem: WsListMenuItem, subIndex: number) => (
                      <ListItemButton
                        selected={subIndex === currentChildStep}
                        onClick={() => {
                          if (subItem.onClick) {
                            subItem.onClick(subItem.id);
                          }
                        }}
                        key={subIndex}
                        sx={{
                          ml: 2,
                          transform:
                            currentChildStep === subIndex ? 'translateX(4px)' : 'translateX(0px)',
                          transition: 'transform 0.5s',
                          color:
                            currentChildStep === subIndex
                              ? WsColors.TheBlues400
                              : WsColors.TertiaryShades500,
                        }}
                      >
                        <Typography mr={2}>{index + 1 + '.' + (subIndex + 1)}</Typography>
                        <ListItemText primary={subItem.label} />
                      </ListItemButton>
                    ))}
                  </List>
                </StyledCollapse>
              )}
            </>
          ))}
        </List>
      </Item>
    </BorderedGrid>

    <Grid item xs={9} bgcolor={WsColors.White} p={2} borderRadius=" 0px 8px 8px 0px">
      {children}
    </Grid>
  </Grid>
);

export default FormWizard;
